"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DigitType;
(function (DigitType) {
    DigitType[DigitType["PID"] = 13] = "PID";
    DigitType[DigitType["HID"] = 11] = "HID";
})(DigitType = exports.DigitType || (exports.DigitType = {}));
var FormatType;
(function (FormatType) {
    FormatType[FormatType["AUTO"] = 0] = "AUTO";
    FormatType[FormatType["THAI"] = 1] = "THAI";
    FormatType[FormatType["ALIEN"] = 2] = "ALIEN";
    FormatType[FormatType["UN"] = 3] = "UN";
})(FormatType = exports.FormatType || (exports.FormatType = {}));
var ValidtionIdType;
(function (ValidtionIdType) {
    ValidtionIdType[ValidtionIdType["THROW_ERROR"] = 0] = "THROW_ERROR";
    ValidtionIdType[ValidtionIdType["RETURN_FALSE"] = 1] = "RETURN_FALSE";
})(ValidtionIdType = exports.ValidtionIdType || (exports.ValidtionIdType = {}));
